var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.titleLabel,
        icon: _vm.titleIcon,
        noReturn: "",
        pageClass: "rtp_details",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          !_vm.details.id || _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                { staticClass: "ml-3 mr-3" },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-h": "start" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                        [_c("back-button")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          attrs: { cols: "4", sm: "3", md: "2", xl: "1" },
                          on: { click: _vm.seeDetails },
                        },
                        [
                          _c("b-button", { staticClass: "back-button" }, [
                            _c("i", {
                              staticClass: "fa-solid fa-rotate-right fs-14px",
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.details.Attachments && _vm.details.Attachments.length
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("attachments.doc_sent_list"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c("document-list", {
                            attrs: { documents: _vm.details.Attachments },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOtherDebtors() && _vm.otherRTP.length > 1
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.rqst_fr_gr"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c("transactions-list", {
                            attrs: {
                              filterBy: "",
                              itemListStyle: "border-radius:0;",
                              actualMessageId: _vm.details.id,
                              messages: _vm.otherRTP,
                              randomId: _vm.randomId,
                              serviceId: _vm.services.PAYMENTS,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOtherDebtors() && _vm.otherRTP.length > 1
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("common.request_details"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _vm.details.endToEndId || _vm.details.uri
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _vm.details.endToEndId
                                    ? _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t("common.invc_ref"),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue: _vm.details.endToEndId,
                                          labelClass: "mb-0",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.details.uri &&
                              _vm.details.uri.startsWith("REQ/ ")
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c(
                                        "form-read-group-label-input",
                                        {
                                          attrs: {
                                            inputLabel: _vm.$t("common.uri"),
                                            colLabelSize: 4,
                                            colInputSize: 8,
                                            inputId: "inputUri",
                                            inputValue:
                                              _vm.details.uri.substring(
                                                5,
                                                _vm.details.uri.length
                                              ),
                                            labelClass: "mb-0",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tooltip-info",
                                              attrs: { slot: "afterInput" },
                                              slot: "afterInput",
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "fa-duotone fa-file-text cursor text-info fs-20px ml-5px",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.copyToClipboard(
                                                        _vm.details.uri.substring(
                                                          5,
                                                          _vm.details.uri.length
                                                        )
                                                      )
                                                    },
                                                    mouseout: function (
                                                      $event
                                                    ) {
                                                      return _vm.copyToClipboardReset()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tooltiptext",
                                                      attrs: { id: "copyUri" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.copy_to_clipboard"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("b-col", {
                                    attrs: { xl: "3", cols: "3" },
                                  }),
                              _vm._v(" "),
                              _c("b-col", {
                                staticClass: "form-group",
                                attrs: { xl: "3", cols: "3" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _vm.showAcceptModifyReasonValidated()
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.rsn"),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      inputValue: _vm.details
                                        .acceptedRemittanceInformation
                                        ? _vm.details
                                            .acceptedRemittanceInformation
                                        : _vm.details.reason,
                                      labelClass: "mb-0",
                                      tooltipLabel:
                                        _vm.concatenatedDateReasonText(
                                          _vm.$t("common.rsn_ask")
                                        ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm.showAcceptModifyReasonCreditor()
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.rsn"),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      inputValue: _vm.details
                                        .acceptedRemittanceInformation
                                        ? _vm.details
                                            .acceptedRemittanceInformation
                                        : _vm.details.reason,
                                      labelClass: "mb-0",
                                      tooltipLabel: _vm.$t(
                                        "requestToPay.modify_reason_debtor"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.rsn"),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      inputValue: _vm.details
                                        .acceptedRemittanceInformation
                                        ? _vm.details
                                            .acceptedRemittanceInformation
                                        : _vm.details.reason,
                                      labelClass: "mb-0",
                                    },
                                  }),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.showAcceptModifyAmountValided()
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t(
                                        "common.amnt_ttl_accept"
                                      ),
                                      inputValue:
                                        _vm.details.acceptedAmount +
                                        " " +
                                        _vm.getCurrencyIcon(
                                          _vm.details.currency
                                        ),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      labelClass: "mb-0",
                                      tooltipLabel:
                                        _vm.concatenatedDateAmountText(
                                          _vm.$t("common.amnt_ttl_ask")
                                        ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm.showAcceptModifyAmountCreditor()
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "align-items-end" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "11" } },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel:
                                                _vm.$t("common.amnt_ttl"),
                                              inputValue:
                                                _vm.details.amount +
                                                " " +
                                                _vm.getCurrencyIcon(
                                                  _vm.details.currency
                                                ),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              labelClass: "mb-0",
                                              tooltipLabel: _vm.$t(
                                                "requestToPay.modify_amount_debtor"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.details.installments
                                        .length
                                        ? _vm.$t("common.amnt_ttl")
                                        : _vm.details.creditNoteAmount
                                        ? _vm.$t("common.amnt_crdt_nt")
                                        : _vm.$t("common.amnt_ttl"),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      inputValue:
                                        (_vm.details.creditNoteAmount
                                          ? _vm.details.creditNoteAmount
                                          : _vm.details.amount) +
                                        " " +
                                        _vm.getCurrencyIcon(
                                          _vm.details.currency
                                        ),
                                      labelClass: "mb-0",
                                    },
                                  }),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t(
                                    "common.status.status_label"
                                  ),
                                  colLabelSize: 4,
                                  colInputSize: 8,
                                  inputValue: _vm.getStatusLabel(
                                    _vm.details.status,
                                    _vm.details.negotStatus
                                  ),
                                  labelClass: "mb-0",
                                  tooltipLabel: _vm.getStatusReason(
                                    _vm.details.status
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.rqst_date"),
                                  colLabelSize: 4,
                                  colInputSize: 8,
                                  inputValue: _vm._f("formatDateTime")(
                                    _vm.details.dateTime
                                  ),
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isHRTP
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.date_expr"),
                                      colLabelSize: 4,
                                      colInputSize: 8,
                                      inputValue: _vm._f("formatDateTime")(
                                        _vm.details.requestedExpirationDate
                                      ),
                                      labelClass: "mb-0",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAcceptModifyDate() &&
                          !_vm.details.installments.length
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c(
                                    "datetime-picker-custom",
                                    {
                                      attrs: {
                                        format: "DD/MM/YYYY H:i:s",
                                        customInputClass: "form-control",
                                        customLabelClass: "mb-0",
                                        inputLabel: _vm.$t("common.exec_date"),
                                        maxLength: 19,
                                        placeholderValue: _vm.$t(
                                          "common.datetime_picker_empty_date"
                                        ),
                                        tooltipLabel: _vm.$t(
                                          "requestToPay.modify_date_creditor"
                                        ),
                                        inputIcon: "fa-solid fa-calendar pl-2",
                                      },
                                      model: {
                                        value: _vm.requestedExecutionDateFormat,
                                        callback: function ($$v) {
                                          _vm.requestedExecutionDateFormat = $$v
                                        },
                                        expression:
                                          "requestedExecutionDateFormat",
                                      },
                                    },
                                    [
                                      _vm.hasPastExecutionDate &&
                                      !_vm.details.installments.length
                                        ? _c("i", {
                                            staticClass:
                                              "fa-duotone fa-warning cursor text-warning fs-20px ml-5px",
                                            attrs: {
                                              slot: "afterInput",
                                              title: _vm.$t(
                                                "common.exec_date_exprd"
                                              ),
                                            },
                                            slot: "afterInput",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm.showAcceptModifyDateValided() &&
                              !_vm.details.installments.length
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c(
                                    "form-read-group-label-input",
                                    {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "common.exec_date_accept"
                                        ),
                                        inputIcon:
                                          "fa-solid fa-calendar text-info",
                                        inputValue: _vm._f("formatDateTime")(
                                          _vm.details
                                            .acceptedRequestedExecutionDatetime
                                        ),
                                        colLabelSize: 4,
                                        colInputSize: 8,
                                        inputType: "date",
                                        disablePastDates: "",
                                        labelClass: "mb-0",
                                        tooltipLabel:
                                          _vm.concatenatedDateAskText(
                                            _vm.$t("common.exec_date_ask")
                                          ),
                                      },
                                    },
                                    [
                                      _vm.hasPastExecutionDate &&
                                      !_vm.details.installments.length
                                        ? _c("i", {
                                            staticClass:
                                              "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                            attrs: {
                                              slot: "afterInput",
                                              title: _vm.$t(
                                                "common.exec_date_exprd"
                                              ),
                                            },
                                            slot: "afterInput",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm.showAcceptModifyDateCreditor() &&
                              !_vm.details.installments.length
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c(
                                    "form-read-group-label-input",
                                    {
                                      attrs: {
                                        inputLabel: _vm.$t("common.exec_date"),
                                        inputIcon:
                                          "fa-solid fa-calendar text-info",
                                        inputValue: _vm._f("formatDateTime")(
                                          _vm.details.requestedExecutionDate
                                        ),
                                        colLabelSize: 4,
                                        colInputSize: 8,
                                        inputType: "date",
                                        disablePastDates: "",
                                        labelClass: "mb-0",
                                        tooltipLabel: _vm.$t(
                                          "requestToPay.modify_date_debtor"
                                        ),
                                      },
                                    },
                                    [
                                      _vm.hasPastExecutionDate &&
                                      !_vm.details.installments.length
                                        ? _c("i", {
                                            staticClass:
                                              "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                            attrs: {
                                              slot: "afterInput",
                                              title: _vm.$t(
                                                "common.exec_date_exprd"
                                              ),
                                            },
                                            slot: "afterInput",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : !_vm.details.installments.length
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { xl: "3", cols: "3" },
                                },
                                [
                                  _c(
                                    "form-read-group-label-input",
                                    {
                                      attrs: {
                                        inputLabel: _vm.$t("common.exec_date"),
                                        colLabelSize: 4,
                                        colInputSize: 8,
                                        inputValue: _vm._f("formatDateTime")(
                                          _vm.details.requestedExecutionDate
                                        ),
                                        labelClass: "mb-0",
                                      },
                                    },
                                    [
                                      _vm.hasPastExecutionDate &&
                                      !_vm.details.installments.length
                                        ? _c("i", {
                                            staticClass:
                                              "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                            attrs: {
                                              slot: "afterInput",
                                              title: _vm.$t(
                                                "common.exec_date_exprd"
                                              ),
                                            },
                                            slot: "afterInput",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c("b-col", {
                                staticClass: "form-group",
                                attrs: { cols: "3" },
                              }),
                          _vm._v(" "),
                          _vm.isHRTP
                            ? _c("b-col", {
                                staticClass: "form-group",
                                attrs: { cols: "3" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.details.paymentRequest
                        ? _c(
                            "b-row",
                            [
                              _vm.details.paymentRequest.debtorIban
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.debtor_ibn_used"
                                          ),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue:
                                            _vm.details.paymentRequest
                                              .debtorIban,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.details.paymentRequest.status
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.payment_status"
                                          ),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue: _vm.$t(
                                            "common.status.payment." +
                                              _vm.details.paymentRequest.status
                                          ),
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canSeePain001 &&
                              _vm.details.paymentRequest.format &&
                              _vm.details.paymentRequest.format.out.id
                                ? _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t("common.flux_out"),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue:
                                            _vm.details.paymentRequest.format
                                              .out.type,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue",
                                        on: {
                                          click: function ($event) {
                                            return _vm.seeXml(
                                              _vm.details.paymentRequest.format
                                                .out,
                                              "payment",
                                              "see"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                        on: {
                                          click: function ($event) {
                                            return _vm.seeXml(
                                              _vm.details.paymentRequest.format
                                                .out,
                                              "payment",
                                              "download"
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.details.installments.length
                    ? _c(
                        "form-accordion",
                        {
                          key: _vm.installmentRefresh,
                          attrs: {
                            title: _vm.$t(
                              "common.request_installments_proposed"
                            ),
                            isTitleUpperCase: false,
                          },
                        },
                        _vm._l(
                          _vm.details.installments,
                          function (installment, installmentIndex) {
                            return _c(
                              "b-row",
                              { key: installmentIndex },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "justify-content-start" },
                                      [
                                        _vm.showAcceptModifyAmount()
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "form-write-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "common.amnt_installment_rtp"
                                                      ),
                                                      inputType: "number",
                                                      colLabelSize: 4,
                                                      colInputSize: 8,
                                                      minValue: 0,
                                                      labelClass: "mb-0",
                                                      tooltipLabel: _vm.$t(
                                                        "requestToPay.modify_amount_creditor"
                                                      ),
                                                    },
                                                    on: {
                                                      blur: _vm.changeDebtorsAmount,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.details
                                                          .installments[
                                                          installmentIndex
                                                        ].Amount,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.details
                                                            .installments[
                                                            installmentIndex
                                                          ],
                                                          "Amount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "details.installments[installmentIndex].Amount",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "common.amnt_installment_rtp"
                                                      ),
                                                      colLabelSize: 4,
                                                      colInputSize: 8,
                                                      inputValue:
                                                        _vm.details
                                                          .installments[
                                                          installmentIndex
                                                        ].Amount +
                                                        " " +
                                                        _vm.getCurrencyIcon(
                                                          _vm.details
                                                            .installments[
                                                            installmentIndex
                                                          ].Currency
                                                        ),
                                                      labelClass: "mb-0",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                        _vm._v(" "),
                                        _vm.showAcceptModifyDate()
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c("datetime-picker-custom", {
                                                  attrs: {
                                                    value:
                                                      _vm.formateInstalmentDate(
                                                        _vm.details
                                                          .installments[
                                                          installmentIndex
                                                        ].Date
                                                      ),
                                                    format: "DD/MM/YYYY H:i:s",
                                                    customInputClass:
                                                      "form-control",
                                                    customLabelClass: "mb-0",
                                                    inputLabel:
                                                      _vm.$t(
                                                        "common.execution_date_label"
                                                      ) +
                                                      " " +
                                                      (installmentIndex + 1),
                                                    maxLength: 19,
                                                    placeholderValue: _vm.$t(
                                                      "common.datetime_picker_empty_date"
                                                    ),
                                                    tooltipLabel: _vm.$t(
                                                      "requestToPay.modify_date_creditor"
                                                    ),
                                                    inputIcon:
                                                      "fa-solid fa-calendar pl-2",
                                                  },
                                                  on: {
                                                    blur: _vm.changeDebtorsDate,
                                                    input: function ($event) {
                                                      return _vm.changeInstallementDates(
                                                        $event,
                                                        installmentIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "3" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "common.execution_date_label"
                                                      ),
                                                      colLabelSize: 4,
                                                      colInputSize: 8,
                                                      inputValue: _vm._f(
                                                        "formatDateTime"
                                                      )(
                                                        _vm.details
                                                          .installments[
                                                          installmentIndex
                                                        ].Date
                                                      ),
                                                      labelClass: "mb-0",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                        _vm._v(" "),
                                        installment.paymentRequest &&
                                        installment.paymentRequest.debtorIban
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "3" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "common.debtor_ibn_used"
                                                      ),
                                                      colLabelSize: 4,
                                                      colInputSize: 8,
                                                      inputValue:
                                                        installment
                                                          .paymentRequest
                                                          .debtorIban,
                                                      labelClass: "mb-0",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        installment.paymentRequest &&
                                        installment.paymentRequest.status
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "form-group",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: "Statut",
                                                      colLabelSize: 4,
                                                      colInputSize: 8,
                                                      inputValue: _vm.$t(
                                                        "common.status.payment." +
                                                          installment
                                                            .paymentRequest
                                                            .status
                                                      ),
                                                      labelClass: "mb-0",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        installment.paymentRequest &&
                                        installment.paymentRequest.format &&
                                        installment.paymentRequest.format.out.id
                                          ? _c(
                                              "b-col",
                                              { attrs: { cols: "3" } },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s("Flux Sortant")
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        installment
                                                          .paymentRequest.format
                                                          .out.type
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.seeXml(
                                                          installment
                                                            .paymentRequest
                                                            .format.out,
                                                          "payment",
                                                          "see"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.seeXml(
                                                          installment
                                                            .paymentRequest
                                                            .format.out,
                                                          "payment",
                                                          "download"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.hasPastExecutionDateInstalment(
                                      installment
                                    )
                                      ? _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "form-group text-right text-warning font-weight-bold",
                                                attrs: {
                                                  xl: "3",
                                                  cols: "3",
                                                  offset: "1",
                                                },
                                              },
                                              [
                                                _c("small", [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-duotone fa-warning cursor",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.exec_date_exprd"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("creation_forms.crdtr_info"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "pt-1 mb-3" },
                        [
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { xl: "3", cols: "3" },
                              },
                              [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("common.my_nme"),
                                    inputValue: _vm.details.creditorName,
                                    labelClass: "mb-0",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.rtp_dbtr_ibn"),
                                  inputValue: _vm.details.creditorBankAccount,
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.my_provider"),
                                  inputValue: _vm.details.creditorBIC,
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("creation_forms.dbtr_info"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "pt-1 mb-3" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.my_nme"),
                                  inputValue: _vm.details.debtorName,
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.rtp_dbtr_ibn"),
                                  inputValue: _vm.details.debtorBankAccount
                                    ? _vm.details.debtorBankAccount
                                    : "-",
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { xl: "3", cols: "3" },
                            },
                            [
                              _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t(
                                    "common.rtp_dbtr_provider"
                                  ),
                                  inputValue: _vm.details.debtorIdProvider,
                                  labelClass: "mb-0",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.details.direction === "0"
                    ? _c(
                        "b-row",
                        { staticClass: "panel-subtitle d-none" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group" },
                            [
                              _vm.showInstantPayment(
                                _vm.details.debtorBankAccount
                              )
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "mt-sm-2",
                                      attrs: {
                                        value: "1",
                                        "unchecked-value": "0",
                                        disabled:
                                          !_vm.waitingForAnswerRTP(
                                            _vm.details.status
                                          ) || _vm.isInstantPayment,
                                      },
                                      model: {
                                        value: _vm.details.instantPayment,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.details,
                                            "instantPayment",
                                            $$v
                                          )
                                        },
                                        expression: "details.instantPayment",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "requestToPay.is_inst_payment"
                                            )
                                          ) +
                                          "\n              " +
                                          _vm._s(
                                            "(" +
                                              _vm.getBankName(
                                                _vm.details.debtorBankAccount
                                              ) +
                                              ")"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.waitingForAnswerRTP(_vm.details.status) &&
                    _vm.details.negotStatus === "10") ||
                  (_vm.waitingForAnswerRTP(_vm.details.status) &&
                    _vm.details.negotStatus === "11") ||
                  _vm.details.status === _vm.status.ACCEPTED ||
                  _vm.details.status === _vm.status.MODIFIED ||
                  _vm.details.status === _vm.status.REVOKED ||
                  _vm.details.status === _vm.status.ACCEPTED_AND_PAYED ||
                  _vm.details.status === _vm.status.ACCEPTED_AND_PAYED_INST ||
                  _vm.details.status === _vm.status.MODIFIED_AND_PAYED ||
                  _vm.details.status === _vm.status.MODIFIED_AND_PAYED_INST ||
                  _vm.details.status === _vm.status.ORDER_GENERATED ||
                  _vm.details.status === _vm.status.MADE ||
                  _vm.details.status === _vm.status.INST_MADE
                    ? _c("div", [
                        (_vm.details.amountResponse.length > 0 &&
                          _vm.details.amountResponse !== _vm.details.amount) ||
                        (_vm.details.executionDateResponse.length > 0 &&
                          _vm.details.requestedExecutionDate !==
                            _vm.details.executionDateResponse)
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "transactionDetailSubHeader",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("common.orig_terms")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _vm.details.amountResponse.length > 0 &&
                                    _vm.details.amountResponse !==
                                      _vm.details.amount
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: { sm: "6" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              staticClass:
                                                "panel-subtitle-detail-demande-form",
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.orig_amount"),
                                                horizontal: "",
                                                inputValue:
                                                  _vm.details.amount +
                                                  " " +
                                                  _vm.getCurrencyIcon(
                                                    _vm.details.currency
                                                  ),
                                                labelClass: "mb-0",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.details.executionDateResponse.length >
                                      0 &&
                                    _vm.details.requestedExecutionDate !==
                                      _vm.details.executionDateResponse
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: { sm: "6" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              staticClass:
                                                "panel-subtitle-detail-demande-form",
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "common.exec_date_orig"
                                                ),
                                                horizontal: "",
                                                inputValue: _vm._f(
                                                  "formatDate"
                                                )(
                                                  _vm.details
                                                    .requestedExecutionDate
                                                ),
                                                labelClass: "mb-0",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.hasPmtResp === "1" &&
                  _vm.details.pmtResp.multPmts.length > 0
                    ? _c(
                        "b-col",
                        {
                          staticClass: "form-group pl-sm-0",
                          attrs: { sm: "6" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "text-decoration-underline-hover mb-0",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("common.pymnts_annoucement", {
                                      install_number:
                                        _vm.details.pmtResp.multPmts.length,
                                    })
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("table", { staticClass: "table" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.installment_amount"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.installment_date"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.details.pmtResp.multPmts,
                                function (installment, index) {
                                  return _c(
                                    "tr",
                                    { key: "installment-" + index },
                                    [
                                      _c("td", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              installment.amount +
                                                " " +
                                                _vm.getCurrencyIcon(
                                                  installment.currency
                                                )
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDate")(
                                              installment.date
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "span",
                                          [
                                            installment.pay === "0" ||
                                            installment.pay === "1"
                                              ? _c("f7-icon", {
                                                  staticClass:
                                                    "icon-transaction-detail",
                                                  attrs: {
                                                    icon: "icon-clock_forward",
                                                  },
                                                })
                                              : installment.pay === "2"
                                              ? _c("f7-icon", {
                                                  staticClass:
                                                    "icon-transaction-detail",
                                                  attrs: {
                                                    icon: "icon-receipt",
                                                  },
                                                })
                                              : _c("f7-icon", {
                                                  staticClass:
                                                    "icon-transaction-detail",
                                                  attrs: { icon: "icon-made" },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (false &&
                    _vm.details.Attachments &&
                    _vm.details.Attachments.length > 0) ||
                  _vm.details.lettrage
                    ? _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        [
                          _vm.details.lettrage
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "transactionDetailSubHeader",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s("Lettrage") +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-2",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.details.lettrage &&
                                                  _vm.details.lettrage.length >
                                                    0
                                                  ? _vm.formatLettrage(
                                                      _vm.details.lettrage
                                                    )
                                                  : "Pas de lettrage"
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.Attachments &&
                          _vm.details.Attachments.length > 0
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "transactionDetailSubHeader",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s("Document") +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("document-list", {
                                    attrs: {
                                      documents: _vm.details.Attachments,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNegotiation()
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "transactionDetailSubHeader" },
                                [
                                  _vm._v(
                                    "\n              Negotiation\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.new_amount"),
                                      horizontal: "",
                                      inputValue:
                                        _vm.details.pmtNegot.amountDebtor +
                                        " " +
                                        _vm.getCurrencyIcon(_vm.details.ccy),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.details.pmtNegot.multiPayments.length > 0
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-decoration-underline-hover",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.pymnts_annoucement",
                                                  {
                                                    install_number:
                                                      _vm.details.pmtNegot
                                                        .multiPayments.length,
                                                  }
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("table", { staticClass: "table" }, [
                                        _c("thead", [
                                          _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_amount"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_date"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.details.pmtNegot.multiPayments,
                                            function (pmt, index) {
                                              return _c(
                                                "tr",
                                                { key: "pmt-" + index },
                                                [
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          pmt.amount +
                                                            " " +
                                                            _vm.getCurrencyIcon(
                                                              _vm.details
                                                                .currency
                                                            )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            pmt.date
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.negotStatus === "12"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "transactionDetailSubHeader" },
                                [
                                  _vm._v(
                                    "\n              Final Terms\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t("common.final_amount"),
                                      horizontal: "",
                                      inputValue:
                                        _vm.details.pmtResp.dbtAmt !== ""
                                          ? _vm.details.pmtResp.dbtAmt +
                                            _vm.getCurrencyIcon(
                                              _vm.details.currency
                                            )
                                          : _vm.details.amount +
                                            _vm.getCurrencyIcon(
                                              _vm.details.currency
                                            ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.details.pmtResp.multPmts.length > 0
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-decoration-underline-hover",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.pymnts_annoucement",
                                                  {
                                                    install_number:
                                                      _vm.details.pmtResp
                                                        .multPmts.length,
                                                  }
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("table", { staticClass: "table" }, [
                                        _c("thead", [
                                          _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_amount"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_date"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.details.pmtResp.multPmts,
                                            function (pmt, index) {
                                              return _c(
                                                "tr",
                                                { key: "pmt-" + index },
                                                [
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          pmt.amount +
                                                            " " +
                                                            _vm.getCurrencyIcon(
                                                              _vm.details
                                                                .currency
                                                            )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            pmt.date
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.status === _vm.status.REVOKED
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.status === _vm.status.REVOKED
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.formsSubTitle.refuse_reason"),
                            "font-size": "1rem",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.details.decisionMessage)),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.cancelMessage && _vm.details.cancelMessage !== ""
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.cancelCode && _vm.details.cancelCode !== ""
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.formsSubTitle.cancel_reason"),
                            "font-size": "1rem",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("p", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.getCancelCodeLabel(
                                            _vm.details.cancelCode
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.details.cancelMessage &&
                                _vm.details.cancelMessage !== ""
                                  ? _c("p", [
                                      _vm._v(_vm._s(_vm.details.cancelMessage)),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.direction === "0" &&
                  _vm.waitingForAnswerRTP(_vm.details.status) &&
                  _vm.details.acceptMultipleInstalments === "1"
                    ? _c("hr", { staticClass: "mx-auto" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.direction === "0" &&
                  _vm.waitingForAnswerRTP(_vm.details.status) &&
                  _vm.details.acceptMultipleInstalments === "1"
                    ? _c(
                        "form-accordion",
                        { attrs: { title: "ECHEANCIER", "font-size": "1rem" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "mt-sm-2",
                                      attrs: {
                                        value: true,
                                        "unchecked-value": false,
                                      },
                                      model: {
                                        value: _vm.showInstallments,
                                        callback: function ($$v) {
                                          _vm.showInstallments = $$v
                                        },
                                        expression: "showInstallments",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "common.ask_multiple_payments_times"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.showInstallments
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          inputType: "number",
                                          inputLabel: "Nombre d'échéances",
                                        },
                                        model: {
                                          value: _vm.numInstallments,
                                          callback: function ($$v) {
                                            _vm.numInstallments = $$v
                                          },
                                          expression: "numInstallments",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showInstallments
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("echeancier", {
                                        attrs: {
                                          numPay: _vm.numInstallments,
                                          min: 1,
                                          amount: _vm.details.amount,
                                          ccy: "€",
                                          deposit: 0,
                                          execDate:
                                            _vm.details.requestedExecutionDate,
                                        },
                                        model: {
                                          value: _vm.multPmts,
                                          callback: function ($$v) {
                                            _vm.multPmts = $$v
                                          },
                                          expression: "multPmts",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("common.formsSubTitle.rqst_to_pay_hstry"),
                        open: true,
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "form-group" },
                        [
                          _c("b-col", [
                            _c("table", { staticClass: "table text-center" }, [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("common.date_request_label")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("common.status.status_label")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.fileFormat &&
                                  _vm.hasRight("xmlDetail_consulter")
                                    ? _c("th", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t("requestToPay.stream_in")
                                            ) +
                                            "\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.fileFormat &&
                                  _vm.hasRight("xmlDetail_consulter")
                                    ? _c("th", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t("requestToPay.stream_out")
                                            ) +
                                            "\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.details.history, function (record) {
                                  return _c("tr", { key: record.id }, [
                                    (record.status !== "20" && _vm.isHRTP) ||
                                    _vm.isSRTP
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("formatDateTime")(
                                                  record.creationDate
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (record.status !== "20" && _vm.isHRTP) ||
                                    _vm.isSRTP
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getHistoryLabel(
                                                  record.status
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.fileFormat &&
                                    _vm.hasRight("xmlDetail_consulter") &&
                                    ((record.status !== "20" && _vm.isHRTP) ||
                                      _vm.isSRTP)
                                      ? _c("td", [
                                          !record.format.in.id ||
                                          record.format.in.id === "0"
                                            ? _c("div", [_vm._v("-")])
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-xl-flex align-items-center justify-content-center",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        record.format.in.type
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c("div", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.seeXml(
                                                            record.format.in,
                                                            "requestToPay",
                                                            "see"
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.seeXml(
                                                            record.format.in,
                                                            "requestToPay",
                                                            "download"
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.fileFormat &&
                                    _vm.hasRight("xmlDetail_consulter") &&
                                    ((record.status !== "20" && _vm.isHRTP) ||
                                      _vm.isSRTP)
                                      ? _c("td", [
                                          !record.format.out.id ||
                                          record.format.out.id === "0"
                                            ? _c("div", [_vm._v("-")])
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-xl-flex align-items-center justify-content-center",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        record.format.out.type
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c("div", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.seeXml(
                                                            record.format.out,
                                                            "requestToPay",
                                                            "see"
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.seeXml(
                                                            record.format.out,
                                                            "requestToPay",
                                                            "download"
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                        ])
                                      : _vm._e(),
                                  ])
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }